const R = require('ramda');
const { sprintf } = require('sprintf-js')
const { url, plural, asset } = require('sci/utils')
const bus = require('sci/std/bus')

class VueUtils {
    install (Vue, options) {
        Vue.mixin({
            ready () {
                document.addEventListener('keydown', (evt) => {
                    if (evt.defaultPrevented) {
                        return evt
                    }

                    if (evt.which === 27) {
                        this.consumeEsc(evt)
                    }
                })
            },
            data () {
                return {
                    escQueue: []
                }
            },
            methods: {
                onEsc (fn) {
                    this.escQueue = [fn].concat(this.escQueue)
                },
                offEsc (fn) {
                    this.escQueue.$remove(fn)
                },
                consumeEsc (evt) {
                    if (this.escQueue.length > 0) {
                        const fn = this.escQueue[0]

                        fn(evt)

                        this.offEsc(fn)
                    }
                }
            }
        })

        Vue.mixin({
            data () {
                return {
                    $user: null,
                    internal$context: null,
                    internal$directContext: null
                }
            },
            created () {
                if (this.$parent && this.$parent.internal$directContext) {
                    this.$changeContext(this.$parent.internal$directContext)
                } else if (this.$parent && this.$parent.internal$context) {
                    this.$changeContext(this.$parent.internal$context)
                }

                this.$user = null
                this.$adblockDetected = window.__userIsUsingAdblockOrRelated
                this.$isDevelopment = window.__isDevelopment

                if (document.hasOwnProperty('SCI_DATA') && document.SCI_DATA.hasOwnProperty('user')) {
                    this.$user = document.SCI_DATA['user']
                    this.$instance = this.$user.instance
                    this.$isSystem = parseInt(this.$user.id) === 1
                    if (this.$user.websites) {
                        this.$website = R.head(this.$user.websites);
                    }
                }
            },
            methods: {
                $contextPath (append = []) {
                    if (!this.internal$context) {
                        return null
                    }

                    let arrayPath = this.internal$context.arrayPath

                    if (append) {
                        arrayPath = [...arrayPath, ...append]
                    }

                    const [head, ...tail] = arrayPath

                    return head + (tail.length ? `^${tail.join('/')}` : '')
                },
                $context () {
                    return this.internal$context || null
                },
                $$contextChanged ([newVal, oldVal]) {
                    this.internal$context = newVal

                    this.$off(`form-context:${oldVal.path}:changed`, this.$$contextChanged)
                    this.$on(`form-context:${newVal.path}:changed`, this.$$contextChanged)

                    return true
                },
                $changeContext (ctx) {
                    this.internal$context = ctx
                    this.$on(`form-context:${ctx.path}:changed`, this.$$contextChanged)
                },
                $pushTopMargin (id, px) {
                    bus.$emit('push-top-margin', { id, size: px })
                },
                $removeTopMargin (id) {
                    bus.$emit('remove-top-margin', { id })
                },
                $keys (obj) {
                    return Object.keys(obj)
                },
                $asset (file, format = null) {
                    if (format === null) {
                        return asset(file)
                    }

                    return sprintf(format, asset(file))
                },
                $routeNameIs (route) {
                    return this.$route.name === route || this.$route.name.indexOf(route) === 0
                },
                $hasSlot (name) {
                    return this._slotContents && !!this._slotContents[name]
                },
                $myParentIsLikeMe () {
                    if (this.$parent) {
                        return this.$parent.constructor.name === this.constructor.name
                    }

                    return true
                },
                $can (permission) {
                    if (this.$user) {
                        return this.$user.guards.hasOwnProperty(permission) && this.$user.guards[permission]
                    } else {
                        return false
                    }
                },
                $nextParent (name) {
                    if (typeof name === 'string') {
                        if (this.$parent && this.$parent.constructor.name === name) {
                            return this.$parent
                        } else if (this.$parent && this.$parent.$nextParent) {
                            return this.$parent.$nextParent(name)
                        } else {
                            return null
                        }
                    } else {
                        if (this.$parent && name(this.$parent)) {
                            return this.$parent
                        } else if (this.$parent && this.$parent.$nextParent) {
                            return this.$parent.$nextParent(name)
                        } else {
                            return null
                        }
                    }
                },
                $parents () {
                    const parents = []
                    let parent = this.$parent

                    do {
                        parents.push(parent)
                        parent = parent.$parent
                    } while (parent)

                    return parents
                },
                $sprintf: sprintf
            }
        })
    }
}

module.exports = VueUtils



// WEBPACK FOOTER //
// ./resources/assets/javascript/microsistec/vue-utils.js